import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'slow-rig-borewells';
// Fixed slots: img[0]=inside blueprint (right), img[1]=beside process (left square), img[2]=panoramic strip
// Additional: img[3+]

const SlowRigBorewells = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="sr-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        {/* Blueprint intro: with img[0] on right if uploaded, else full-width */}
        {imgs[0] ? (
          <div className="sr-blueprint-wrap">
            <div className="sr-blueprint">
              <h2>About {data.title}</h2>
              <p>{data.intro}</p>
              <p>{data.intro2}</p>
            </div>
            <div className="sr-blueprint-img">
              <img src={imgs[0].url} alt={imgs[0].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="sr-blueprint-solo">
            <h2>About {data.title}</h2>
            <p>{data.intro}</p>
            <p>{data.intro2}</p>
          </div>
        )}

        {/* Process: img[1] on left only if uploaded */}
        {data.processSteps && data.processSteps.length > 0 && (
          <div className="sr-process-section">
            <h2>{data.processTitle}</h2>
            {imgs[1] ? (
              <div className="sr-proc-with-img">
                <div className="sr-proc-img">
                  <img src={imgs[1].url} alt={imgs[1].caption || data.title} />
                </div>
                <div className="sr-process-row">
                  {data.processSteps.map((s) => (
                    <div className="sr-proc-card" key={s.step}>
                      <div className="sr-proc-num">{s.step}</div>
                      <div>
                        <h4>{s.title}</h4>
                        <p>{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="sr-process-row">
                {data.processSteps.map((s) => (
                  <div className="sr-proc-card" key={s.step}>
                    <div className="sr-proc-num">{s.step}</div>
                    <div>
                      <h4>{s.title}</h4>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Panoramic strip — only if uploaded */}
        {imgs[2] && (
          <div className="sr-pano-strip">
            <img src={imgs[2].url} alt={imgs[2].caption || data.title} />
          </div>
        )}

        {data.features && data.features.length > 0 && (
          <div className="sr-feat-grid">
            <h2>{data.featuresTitle}</h2>
            {data.features.map((f) => (
              <div className="sr-feat" key={f.title}>
                <span>{f.icon}</span>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="sr-specs">
            <h2>{data.specsTitle}</h2>
            <table><tbody>
              {data.specs.map((row, i) => <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
            </tbody></table>
          </div>
        )}

        {imgs.length > 3 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(3).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default SlowRigBorewells;
